const token = 'MDI1UzdVNjA6Zjk1OTI5MjktOTc4My00ZmZkLWI1MWUtMjgxYzlmYTU5M2Nj';
function submitMsg(author, email, title, msg) {
    return new Promise((res, rej) => {
        $.ajax({
            url: 'https://eu-central-1.data.tidbcloud.com/api/v1beta/app/dataapp-rjKGJmQm/endpoint/feedbacks',
            type: 'POST',
            headers: {
                Authorization: 'Basic ' + token,
                'Content-Type': 'application/json',
            },
            data: JSON.stringify({ name: author, email, title, comments: msg }),
        })
            .done(res)
            .fail(rej);
    });
}

module.exports = submitMsg;
